import { LOCALE_BCP47 } from '@staiter/shared';
import Decimal from 'decimal.js-light';
import { displaySign } from './sign.js';
export function formatNumber(value, locale, options) {
    if (value === null || value === undefined || value === '')
        return '—';
    const num = value instanceof Decimal ? value.toNumber() : typeof value === 'string' ? Number(value) : value;
    if (Number.isNaN(num))
        return '—';
    // F101 (NC-45): знак минус U+2212 в показе; поля ввода берут `asciiSign` поверх.
    return displaySign(new Intl.NumberFormat(LOCALE_BCP47[locale], {
        maximumFractionDigits: 2,
        ...options,
    }).format(num));
}
//# sourceMappingURL=number.js.map